import { useCallback } from 'react'

import { useSetFocus } from '@please/lrud'
import { useLocation, useNavigate } from 'react-router-dom'

import { focusIds } from '@/constants/focus'
import { paths } from '@/constants/paths'
import useStore from '@/store/useStore'
import { MenuItemType } from '@/types/menuTypes'

export const useMenuItem = (subMenuPath?: string) => {
  const closePagePopup = useStore((state) => state.popup.closePagePopup)
  const setCurrentEvent = useStore((state) => state.common.setCurrentEvent)
  const setListPopup = useStore((state) => state.common.setListPopup)
  const setCalendarSelectedIndex = useStore(
    (state) => state.common.setCalendarSelectedIndex,
  )
  const setSubMenuType = useStore((state) => state.common.setSubMenuType)
  const { pathname } = useLocation()
  const setFocus = useSetFocus()
  const navigate = useNavigate()

  const checkIsActiveMenuItem = (menuItem: MenuItemType) => {
    const menuItemPath = subMenuPath
      ? `${subMenuPath}/${menuItem.id}`
      : menuItem.path
    return (
      pathname === menuItemPath ||
      (pathname?.includes(paths.PAGE) && menuItemPath === paths.CATALOGUE)
    )
  }

  const selectMenuItem = useCallback(
    (menuItem: MenuItemType) => {
      const currentEvent = useStore.getState().common.currentEvent
      if (menuItem.hasSubmenu && menuItem.id === focusIds.CATALOGUE) {
        setSubMenuType(menuItem.id)
      } else {
        closePagePopup()
        setCurrentEvent(null)
        setListPopup(null)

        if (checkIsActiveMenuItem(menuItem)) {
          if (subMenuPath) {
            setFocus(`${focusIds.PAGE}${focusIds.CONTAINER_MOD}`)
            return
          }
          setFocus(focusIds.CONTENT)
          return
        }
        if (subMenuPath) {
          navigate(`${subMenuPath}/${menuItem.id}`)
          setFocus(`${focusIds.PAGE}${focusIds.CONTAINER_MOD}`)
          setSubMenuType(null)
        } else {
          menuItem.path && navigate(menuItem.path)
          menuItem.path === paths.CALENDAR && setCalendarSelectedIndex(0)
        }

        currentEvent && setCurrentEvent(null)
      }
    },
    [pathname],
  )
  return { checkIsActiveMenuItem, selectMenuItem }
}
